module.exports = __webpack_public_path__ + "bg.d735b0216266a9201f6f.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles